import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiPaginationResponse, ApiResponse } from 'types';
import { generateFormData } from 'utils';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import {
  DeleteMediaRequest,
  FetchMediaPayload,
  GetCollectionsPayload,
  IMedia,
  IMediaCollection,
  UpdateMediaRequest,
  UploadMediaRequest,
  UploadMediaResponse,
} from '../types/media.types';

export const mediaApi = createApi({
  reducerPath: 'mediaApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/media`),
  endpoints: (builder) => ({
    fetchMedia: builder.mutation<ApiPaginationResponse<IMedia[]>, FetchMediaPayload>({
      query: (payload) => ({
        url: '',
        method: 'POST',
        body: payload,
      }),
    }),

    fetchCollections: builder.query<ApiResponse<IMediaCollection[]>, GetCollectionsPayload>({
      query: (params) => ({
        url: '/collections-info',
        method: 'GET',
        params,
      }),
    }),

    uploadMedia: builder.mutation<UploadMediaResponse, UploadMediaRequest>({
      query: (payload) => ({
        url: `/upload/${payload.params.modelType}/${payload.params.id}?collection=${payload.params.collection}`,
        method: 'POST',
        body: generateFormData(payload.body),
      }),
    }),

    updateMedia: builder.mutation<UploadMediaResponse, UpdateMediaRequest>({
      query: (params) => ({
        url: `/${params.id}`,
        method: 'PATCH',
        params,
      }),
    }),

    deleteMedia: builder.mutation<UploadMediaResponse, DeleteMediaRequest>({
      query: (payload) => ({
        url: `/${payload.id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useUploadMediaMutation,
  useDeleteMediaMutation,
  useFetchMediaMutation,
  useUpdateMediaMutation,
  useLazyFetchCollectionsQuery,
} = mediaApi;
